import {AccountTypeOrderDocument} from '@transactions/graphql';
import type {DataProxy} from '@apollo/client';

export const setAccountTypeOrder = (store: DataProxy, keys: string[]) => {
  store.writeQuery({
    query: AccountTypeOrderDocument,
    data: {
      accountTypeOrder: keys,
    },
  });
};
